import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="reviewable-container">
  <div class="reviewable-list">
    {{#if this.reviewables}}
      <LoadMore @selector=".reviewable-item" @action={{action "loadMore"}}>
        <div class="reviewables">
          {{#each this.reviewables as |r|}}
            <ReviewableItem @reviewable={{r}} @remove={{action "remove"}} />
          {{/each}}
        </div>
      </LoadMore>
      <ConditionalLoadingSpinner @condition={{this.reviewables.loadingMore}} />
    {{else}}
      <div class="no-review">
        {{i18n "review.none"}}
      </div>
    {{/if}}
  </div>

  <div class="reviewable-filters">
    <div class="reviewable-filter">
      <label class="filter-label">
        {{i18n "review.filters.status"}}
      </label>
      <ComboBox
        @value={{this.filterStatus}}
        @content={{this.statuses}}
        @onChange={{fn (mut this.filterStatus)}}
      />
    </div>

    {{#if this.filtersExpanded}}

      <span>
        <PluginOutlet
          @name="above-review-filters"
          @connectorTagName="div"
          @outletArgs={{hash
            model=this.model
            additionalFilters=this.additionalFilters
          }}
        />
      </span>

      <div class="reviewable-filter">
        <label class="filter-label">
          {{i18n "review.filters.type.title"}}
        </label>
        <ComboBox
          @value={{this.filterType}}
          @content={{this.allTypes}}
          @onChange={{fn (mut this.filterType)}}
          @options={{hash none="review.filters.type.all"}}
        />
      </div>

      <div class="reviewable-filter">
        <label class="filter-label">
          {{i18n "review.filters.priority.title"}}
        </label>
        <ComboBox
          @value={{this.filterPriority}}
          @content={{this.priorities}}
          @onChange={{fn (mut this.filterPriority)}}
        />
      </div>

      <div class="reviewable-filter">
        <label class="filter-label">
          {{i18n "review.filters.category"}}
        </label>
        <CategoryChooser
          @value={{this.filterCategoryId}}
          @onChange={{fn (mut this.filterCategoryId)}}
          @options={{hash none="review.filters.all_categories"}}
        />
      </div>

      <div class="reviewable-filter topic-filter">
        <label class="filter-label">
          {{i18n "review.filtered_reviewed_by"}}
        </label>
        <EmailGroupUserChooser
          @value={{this.filterReviewedBy}}
          @onChange={{action "updateFilterReviewedBy"}}
          @options={{hash
            maximum=1
            excludeCurrentUser=false
            fullWidthWrap=true
          }}
        />
      </div>

      <div class="reviewable-filter topic-filter">
        <label class="filter-label">
          {{i18n "review.filtered_user"}}
        </label>
        <EmailGroupUserChooser
          @value={{this.filterUsername}}
          @onChange={{action "updateFilterUsername"}}
          @options={{hash
            maximum=1
            excludeCurrentUser=false
            fullWidthWrap=true
          }}
          class="user-selector"
        />
      </div>

      {{#if this.filterTopic}}
        <div class="reviewable-filter topic-filter">
          <label class="filter-label">
            {{i18n "review.filtered_topic"}}
          </label>
          <DButton
            @label="review.show_all_topics"
            @icon="times"
            @action={{action "resetTopic"}}
            class="btn-default"
          />
        </div>
      {{/if}}

      <div class="reviewable-filter date-range">
        <label class="filter-label">
          {{i18n "review.date_filter"}}
        </label>
        <DateTimeInputRange
          @from={{this.filterFromDate}}
          @to={{this.filterToDate}}
          @onChange={{this.setRange}}
          @showFromTime={{false}}
          @showToTime={{false}}
        />
      </div>

      <div class="reviewable-filter sort-order">
        <label class="filter-label">
          {{i18n "review.order_by"}}
        </label>
        <ComboBox
          @value={{this.filterSortOrder}}
          @content={{this.sortOrders}}
          @onChange={{fn (mut this.filterSortOrder)}}
        />
      </div>
    {{/if}}

    <div class="reviewable-filters-actions">
      <DButton
        @icon="sync"
        @label="review.filters.refresh"
        @action={{action "refresh"}}
        class="btn-primary refresh"
      />

      {{#if this.site.mobileView}}
        <DButton
          @label="show_help"
          @icon={{this.toggleFiltersIcon}}
          @action={{action "toggleFilters"}}
          class="btn-default expand-secondary-filters"
        />
      {{/if}}
    </div>
  </div>
</div>
*/
{
  "id": "TtVl3dul",
  "block": "[[[10,0],[14,0,\"reviewable-container\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"reviewable-list\"],[12],[1,\"\\n\"],[41,[30,0,[\"reviewables\"]],[[[1,\"      \"],[8,[39,1],null,[[\"@selector\",\"@action\"],[\".reviewable-item\",[28,[37,2],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"reviewables\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"reviewables\"]]],null]],null],null,[[[1,\"            \"],[8,[39,5],null,[[\"@reviewable\",\"@remove\"],[[30,1],[28,[37,2],[[30,0],\"remove\"],null]]],null],[1,\"\\n\"]],[1]],null],[1,\"        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[39,6],null,[[\"@condition\"],[[30,0,[\"reviewables\",\"loadingMore\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"no-review\"],[12],[1,\"\\n        \"],[1,[28,[35,7],[\"review.none\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"reviewable-filters\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"reviewable-filter\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n        \"],[1,[28,[35,7],[\"review.filters.status\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,8],null,[[\"@value\",\"@content\",\"@onChange\"],[[30,0,[\"filterStatus\"]],[30,0,[\"statuses\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"filterStatus\"]]],null]],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"filtersExpanded\"]],[[[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[8,[39,11],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-review-filters\",\"div\",[28,[37,12],null,[[\"model\",\"additionalFilters\"],[[30,0,[\"model\"]],[30,0,[\"additionalFilters\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"reviewable-filter\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.filters.type.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,8],null,[[\"@value\",\"@content\",\"@onChange\",\"@options\"],[[30,0,[\"filterType\"]],[30,0,[\"allTypes\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"filterType\"]]],null]],null],[28,[37,12],null,[[\"none\"],[\"review.filters.type.all\"]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"reviewable-filter\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.filters.priority.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,8],null,[[\"@value\",\"@content\",\"@onChange\"],[[30,0,[\"filterPriority\"]],[30,0,[\"priorities\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"filterPriority\"]]],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"reviewable-filter\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.filters.category\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,13],null,[[\"@value\",\"@onChange\",\"@options\"],[[30,0,[\"filterCategoryId\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"filterCategoryId\"]]],null]],null],[28,[37,12],null,[[\"none\"],[\"review.filters.all_categories\"]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"reviewable-filter topic-filter\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.filtered_reviewed_by\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,14],null,[[\"@value\",\"@onChange\",\"@options\"],[[30,0,[\"filterReviewedBy\"]],[28,[37,2],[[30,0],\"updateFilterReviewedBy\"],null],[28,[37,12],null,[[\"maximum\",\"excludeCurrentUser\",\"fullWidthWrap\"],[1,false,true]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"reviewable-filter topic-filter\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.filtered_user\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,14],[[24,0,\"user-selector\"]],[[\"@value\",\"@onChange\",\"@options\"],[[30,0,[\"filterUsername\"]],[28,[37,2],[[30,0],\"updateFilterUsername\"],null],[28,[37,12],null,[[\"maximum\",\"excludeCurrentUser\",\"fullWidthWrap\"],[1,false,true]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"filterTopic\"]],[[[1,\"        \"],[10,0],[14,0,\"reviewable-filter topic-filter\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"review.filtered_topic\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,15],[[24,0,\"btn-default\"]],[[\"@label\",\"@icon\",\"@action\"],[\"review.show_all_topics\",\"times\",[28,[37,2],[[30,0],\"resetTopic\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"reviewable-filter date-range\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.date_filter\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,16],null,[[\"@from\",\"@to\",\"@onChange\",\"@showFromTime\",\"@showToTime\"],[[30,0,[\"filterFromDate\"]],[30,0,[\"filterToDate\"]],[30,0,[\"setRange\"]],false,false]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"reviewable-filter sort-order\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"filter-label\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"review.order_by\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,8],null,[[\"@value\",\"@content\",\"@onChange\"],[[30,0,[\"filterSortOrder\"]],[30,0,[\"sortOrders\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"filterSortOrder\"]]],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"reviewable-filters-actions\"],[12],[1,\"\\n      \"],[8,[39,15],[[24,0,\"btn-primary refresh\"]],[[\"@icon\",\"@label\",\"@action\"],[\"sync\",\"review.filters.refresh\",[28,[37,2],[[30,0],\"refresh\"],null]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"site\",\"mobileView\"]],[[[1,\"        \"],[8,[39,15],[[24,0,\"btn-default expand-secondary-filters\"]],[[\"@label\",\"@icon\",\"@action\"],[\"show_help\",[30,0,[\"toggleFiltersIcon\"]],[28,[37,2],[[30,0],\"toggleFilters\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"r\"],false,[\"if\",\"load-more\",\"action\",\"each\",\"-track-array\",\"reviewable-item\",\"conditional-loading-spinner\",\"i18n\",\"combo-box\",\"fn\",\"mut\",\"plugin-outlet\",\"hash\",\"category-chooser\",\"email-group-user-chooser\",\"d-button\",\"date-time-input-range\"]]",
  "moduleName": "discourse/templates/review-index.hbs",
  "isStrictMode": false
});